export default __webpack_public_path__ + "static/media/star_health.b4183fff.svg";